import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { B as BannerAlertWrapper, a as BannerAlertIconWrapper, b as BannerAlertContent } from './BannerAlert.styles-Y6YSWMdr.js';
import { I as Icon } from '../Icon/Icon-CoM8rI0H.js';
import { T as Text } from '../Text/Text-CO4HftGt.js';
import { C as CloseButton } from '../Button/CloseButton/CloseButton-B_qumqxY.js';
import { i as infoCircle, e as exclamationTriangle, a as exclamation } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const chooseIcon = $variant => {
  switch ($variant) {
    case 'error':
      return exclamation;
    case 'warning':
      return exclamationTriangle;
    default:
      return infoCircle;
  }
};
const BannerAlert = ({
  variant = 'info',
  withCloseButton = variant !== 'error',
  closeButtonLabel = 'Dismiss message',
  children,
  onClose,
  ...rest
}) => /*#__PURE__*/React__default.createElement(BannerAlertWrapper, _extends({}, rest, {
  $variant: variant
}), /*#__PURE__*/React__default.createElement(BannerAlertIconWrapper, null, /*#__PURE__*/React__default.createElement(Icon, {
  type: chooseIcon(variant),
  size: "small"
})), /*#__PURE__*/React__default.createElement(BannerAlertContent, null, /*#__PURE__*/React__default.createElement(Text, {
  renderAs: "span"
}, children)), withCloseButton && /*#__PURE__*/React__default.createElement(CloseButton, {
  label: closeButtonLabel,
  onClick: onClose,
  size: "small"
}));

export { BannerAlert as B };
//# sourceMappingURL=BannerAlert-BCZ_MbMY.js.map
